module.exports = __webpack_public_path__ + "1bf56c531701f693f99ae590862d838d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/tree-house-empty.png
// module id = 332
// module chunks = 0